var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDone = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0.05 17 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 95"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.143 8.532a6.5 6.5 0 1 1 0-.076z",
  fill: "#26890d",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5 10.1a8.5 8.5 0 1 1 0-.1z",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: 3,
  stroke: "#26890e",
  fill: "transparent",
  transform: "translate(.995 .809) scale(.76471)"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m5.372 8.549 2.614 2.614 4.249-4.248",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  stroke: "#faf6f2",
  fill: "transparent",
  "data-name": "Path 280379"
})));
export default SvgDone;